import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TooltipTextComponent } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-details-side-panel-template',
    imports: [TooltipTextComponent],
    templateUrl: './details-side-panel-template.component.html',
    styleUrl: './details-side-panel-template.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsSidePanelTemplateComponent {
    @Input()
    label!: string;

    @Input()
    value!: string | undefined;
}
